/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'./LocalFilterDialogAPI',
	'../../../../DynamicFileLoader',
	'../../../../util/ToolbarHelper',
	'../../../../widgets/livewidget/nls/StringResources'
], (APIFactory, LocalFilterDialogAPI, DynamicFileLoader, ToolbarHelper, resources) => {

	class LocalFilterDialog {

		constructor(options) {
			this.api = APIFactory.createAPI(this, [LocalFilterDialogAPI]);
			this._toolbarHelper = new ToolbarHelper();
			this.dashboard = options.dashboardAPI;
			this.content = options.content;
		}

		renderDialog(metadataColumnId, renderNode, editorOptions) {
			const pageContext = this.dashboard.getFeature('PageContextService').getPageContext();
			const visualization = this.content.getFeature('Visualization');
			const metadataColumn = visualization.getDataSource().getMetadataColumn(metadataColumnId);
			const editFilterAction = 'dashboard-analytics/visualizations/interactions/FilterDropAction';
			return DynamicFileLoader.load([editFilterAction]).then((modules) => {
				const FilterDropAction = modules[0];
				const fAction = new FilterDropAction(visualization, metadataColumn, pageContext, this.dashboard );

				if (!editorOptions.forceOpen && metadataColumn.isNamedSet()) {
					const localFilters = visualization.getLocalFilters();
					localFilters.addFilter(fAction.itemContext, {
						command: 'replace',
						exclude: false,
						valueDataItem: metadataColumn.getId(),
						type: metadataColumn.isProperty() ? 'display' : undefined
					});
				} else {
					const sDialogModule = fAction.getEditorModuleName();
					const viewOptions = fAction.getViewOptions();

					return DynamicFileLoader.load([sDialogModule]).then((modules) => {
						const view = new modules[0](viewOptions);

						const preloadDone = (this.preload && this.preload()) || ((view.preload) ? view.preload() : Promise.resolve()); // required for unit tests
						return preloadDone.then(this._createContextFilter.bind(this, view, renderNode, editorOptions))
							.then(() => {
								return view.renderCallBack(this._toolbarHelper.getToolbar());
							});
					});
				}

			});
		}

		_createContextFilter(view, parentNode, editorOptions) {
			var actions = [{
				responsive: false,
				editable: false,
				changedAction: null,
				subView: view,
				type: 'SubView'
			}];

			// We need to send the popoverContentClass along when creating the toolbar
			// So popovers are sized and positioned correctly
			// Defect #205657, #208527; APAR #123258;
			editorOptions.popoverContentClass = view.$el && view.$el.attr('class');

			this._toolbarHelper.buildActionToolbar(actions, parentNode, resources.get('toolbarActionFilter'), editorOptions);
		}

		getAPI() {
			return this.api;
		}
	}

	return LocalFilterDialog;
});
